export type { MissingElementProps } from '../../types/missing-element';
export { MissingElement } from './adapters/inbound/MissingElement';
